<template>
  <div v-if="!isCalculationComplete" class="char-width__wrapper">
    <span
      v-for="char in CHAR_LIST"
      :key="`${FONT.INTER_16_BOLD}${char}`"
      :ref="FONT.INTER_16_BOLD"
      class="char-width__char bold"
      >{{ char }}</span
    >
    <span
      v-for="char in CHAR_LIST"
      :key="`${FONT.INTER_14_BOLD}${char}`"
      :ref="FONT.INTER_14_BOLD"
      class="char-width__char char-width__char--sm bold"
      >{{ char }}</span
    >
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as types from '@/store/mutation-types'
import { FONT } from 'shared/ACharWidth/enums'

/* ASCII CODES */
const START_CODE = 32
const END_CODE = 126

const CHAR_LIST = new Array(END_CODE - START_CODE)
  .fill()
  .map((_, index) => String.fromCharCode(index + START_CODE))

export default {
  name: 'ACharWidth',
  data() {
    return { CHAR_LIST, FONT, isCalculationComplete: false }
  },
  methods: {
    ...mapMutations({
      setCharSizeMap: types.SET_CHAR_SIZE
    }),
    getSizeMapByFont(font) {
      return this.$refs[font]
        .map(ref => parseFloat(window.getComputedStyle(ref).width))
        .reduce(
          (acc, width, index) => ({
            ...acc,
            [CHAR_LIST[index]]: width
          }),
          {}
        )
    }
  },
  mounted() {
    const inter16Bold = this.getSizeMapByFont(FONT.INTER_16_BOLD)
    const inter14Bold = this.getSizeMapByFont(FONT.INTER_14_BOLD)

    const resultMap = {
      [FONT.INTER_16_BOLD]: inter16Bold,
      [FONT.INTER_14_BOLD]: inter14Bold
    }

    this.setCharSizeMap(resultMap)
    this.isCalculationComplete = true
  }
}
</script>

<style lang="scss" scoped>
.char-width__wrapper {
  position: absolute;
  visibility: hidden;
  top: 0;
  left: 0;

  .char-width__char {
    font-size: 16px;
    line-height: 16px;
    display: inline-block;
    white-space: pre;
  }

  .char-width__char--sm {
    font-size: 14px;
  }
}
</style>
